import {routerReducer} from 'react-router-redux';
import {combineReducers} from 'redux';

import navigation from './navigation';
import notifications from './notifications';
import viewport from './viewport';
import volume from './volume';

import battleRoyaleReducers from '../portfolio/battle-royale/reducers';

export default combineReducers({
    navigation,
    notifications,
    viewport,
    volume,
    router: routerReducer,
    ...battleRoyaleReducers
});


// WEBPACK FOOTER //
// ./src/reducers/index.js